import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import { setupCalendar } from 'v-calendar';
import '@formatjs/intl-relativetimeformat/dist/locale-data/de';
import '@formatjs/intl-relativetimeformat/dist/locale-data/fr';
import '@formatjs/intl-relativetimeformat/dist/locale-data/en';
import defaultLocalesMessages from './languages/de';


Vue.use(VueI18n);

setupCalendar({
  fr: {
    firstDayOfWeek: 1,
    masks: {
      L: 'DD/MM/YYYY',
    },
  },
  de: {
    firstDayOfWeek: 1,
    masks: {
      L: 'DD.MM.YYYY',
    },
  },
  en: {
    firstDayOfWeek: 1,
    masks: {
      L: 'DD/MM/YYYY',
    },
  },
});

export const availableLocales = ['de', 'fr', 'en']; // First locale is the default

export const defaultLocale = availableLocales[0];

const loadedLocales = [defaultLocale]; // our default language that is preloaded
const defaultMessagesConfig = {};
defaultMessagesConfig[defaultLocale] = {
  ...defaultLocalesMessages,
};

export const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages: defaultMessagesConfig,
  silentTranslationWarn: true, // removes -> [vue-i18n] Value of key '<<value>>' is not a string!
});

function setI18nLocale(locale) {
  i18n.locale = locale;
  axios.defaults.headers.common['Accept-Language'] = locale;
  document.querySelector('html').setAttribute('lang', locale);

  return locale;
}

export function loadLanguageAsync(language) {
  if (!availableLocales.includes(language)) { // If locale doesn't exist, the defaultLocale is set
    setI18nLocale(defaultLocale);

    return Promise.resolve(defaultLocale);
  }
  if (!loadedLocales.includes(language)) {
    // eslint-disable-next-line prefer-template
    return import('@/i18n/languages/' + language).then((localeModule) => {
      i18n.setLocaleMessage(language, localeModule.default);
      loadedLocales.push(language);

      return setI18nLocale(language);
    });
  }

  return Promise.resolve(setI18nLocale(language));
}
